import {
  ModalSectionActionType as ActionType,
  WelcomeModalSectionData as SectionData,
} from './components/welcome-modal-section/WelcomeModalSection';
import { useMemo } from 'react';
import { useAppDispatch } from '@customer/store/hooks';
import { openSidePanel, SidePanel } from '@customer/store/slices/globalSlice';

const SECTION_TECH_LIBRARY: SectionData = {
  title: 'TechnicalLibrary',
  description: 'WelcomeTechnicalLibraryDescription',
  actions: [
    {
      type: ActionType.Link,
      url: '/techlibrary',
      label: 'ViewLibrary',
    },
  ],
};

const SECTION_EXPLORE: SectionData = {
  title: 'ExploreFullCapabilities',
  description: 'WelcomeExploreDescription',
  actions: [
    {
      type: ActionType.Link,
      url: '/home',
      label: 'ImprovedReporting',
    },
    {
      type: ActionType.Link,
      url: '/assets',
      label: 'AssetInventory',
    },
    {
      type: ActionType.Link,
      url: '/health',
      label: 'FleetHealth',
    },
    {
      type: ActionType.Link,
      url: '/performance',
      label: 'AssetInteractions',
    },
  ],
};

export const useWelcomeModalSections = (): SectionData[] => {
  const dispatch = useAppDispatch();

  const sections: SectionData[] = useMemo(() => {
    const sectionHelpPanel: SectionData = {
      title: 'HelpPanel',
      description: 'WelcomeHelpDescription',
      actions: [
        {
          type: ActionType.Action,
          label: 'OpenHelpPanel',
          action: () => {
            dispatch(openSidePanel({ sidePanel: SidePanel.Help }));
          },
        },
      ],
    };

    return [SECTION_TECH_LIBRARY, sectionHelpPanel, SECTION_EXPLORE];
  }, [dispatch]);

  return sections;
};

export default useWelcomeModalSections;
